<div style="height: 100%; width: 100%;">
  <router-outlet></router-outlet>
</div>